import { helpers } from "vuelidate/lib/validators";
import moment from "moment";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Moment.js based maximum with current date validator
 */
export const maxCurrentDateValidator = (maxDate?: string) =>
  helpers.withParams(
    {
      type: "maxCurrentDate",
      value: maxDate
    },
    (value: string) => {
      return (
        moment(value).isSameOrBefore(moment()) &&
        moment(value).isSameOrBefore(maxDate)
      );
    }
  );
